__turbopack_context__.v({
  "active": "Header-module-scss-module__P7cjuG__active",
  "activeLogo": "Header-module-scss-module__P7cjuG__activeLogo",
  "beta-version": "Header-module-scss-module__P7cjuG__beta-version",
  "bottom-navbar": "Header-module-scss-module__P7cjuG__bottom-navbar",
  "bottom-right-container": "Header-module-scss-module__P7cjuG__bottom-right-container",
  "bottom-route-name": "Header-module-scss-module__P7cjuG__bottom-route-name",
  "bottom-svg": "Header-module-scss-module__P7cjuG__bottom-svg",
  "bottom-tab-container": "Header-module-scss-module__P7cjuG__bottom-tab-container",
  "children-container": "Header-module-scss-module__P7cjuG__children-container",
  "dataMuniIcon": "Header-module-scss-module__P7cjuG__dataMuniIcon",
  "datamuniHeaderTitle": "Header-module-scss-module__P7cjuG__datamuniHeaderTitle",
  "dropdown-item": "Header-module-scss-module__P7cjuG__dropdown-item",
  "dropdown-menu": "Header-module-scss-module__P7cjuG__dropdown-menu",
  "dropdown-toggle": "Header-module-scss-module__P7cjuG__dropdown-toggle",
  "explore-nav": "Header-module-scss-module__P7cjuG__explore-nav",
  "header": "Header-module-scss-module__P7cjuG__header",
  "login-button": "Header-module-scss-module__P7cjuG__login-button",
  "login-button-custom": "Header-module-scss-module__P7cjuG__login-button-custom",
  "loginClassName": "Header-module-scss-module__P7cjuG__loginClassName",
  "logout-button": "Header-module-scss-module__P7cjuG__logout-button",
  "logout-text": "Header-module-scss-module__P7cjuG__logout-text",
  "nav-link-login": "Header-module-scss-module__P7cjuG__nav-link-login",
  "navBar": "Header-module-scss-module__P7cjuG__navBar",
  "nav_outline": "Header-module-scss-module__P7cjuG__nav_outline",
  "nav_solid": "Header-module-scss-module__P7cjuG__nav_solid",
  "profile-container": "Header-module-scss-module__P7cjuG__profile-container",
  "profile-info": "Header-module-scss-module__P7cjuG__profile-info",
  "profile-picture": "Header-module-scss-module__P7cjuG__profile-picture",
  "right-container": "Header-module-scss-module__P7cjuG__right-container",
  "route-name": "Header-module-scss-module__P7cjuG__route-name",
  "tab-container": "Header-module-scss-module__P7cjuG__tab-container",
  "user-name": "Header-module-scss-module__P7cjuG__user-name",
  "user-name-container": "Header-module-scss-module__P7cjuG__user-name-container",
  "user-name-image": "Header-module-scss-module__P7cjuG__user-name-image",
  "user-section": "Header-module-scss-module__P7cjuG__user-section",
  "username": "Header-module-scss-module__P7cjuG__username",
});
